import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

/**
 * 비회원이 회원가입 유도 배너 탭했을 때 발화.
 * iOS `LikedProductLoggerType.clickSignUp` → `CLICK_SIGN_UP_FOR_FOLDER` 와 동일.
 * SCREEN 은 AnalyticsContext 에서 자동 주입.
 */
export const useLogClickSignUpForFolder = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(() => {
    logAnalyticsEvent({ name: 'CLICK_SIGN_UP_FOR_FOLDER' });
  }, [logAnalyticsEvent]);
};
